import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { InstanceConfigHolderService } from 'ng-busy';

@Component({
  template: `
    <div class="nec-loading-sign">
      <div class="nec-loading-spinner-line">
        <div class="animation nec-loading-spinner"></div>
        <div class="nec-loading-text">{{ message }}</div>
      </div>

      <div class="nec-loading-tips">
        <span class="nec-loading-tip-label">TIPSï¼</span>
        {{ tip }}
      </div>
    </div>
  `
})
export class NecLoadingComponent implements OnInit, OnDestroy {
  private tips = [
    'å¼åå­¦ä¹ ç­ãä¸¾åå¤§åä¼è®®ï¼èç³»æä»¬è¯ç¨ãå¸®ç»§æãåè½ï¼ä¸ºæ¨æä¾åè´¹çä¸ä¸ä¼è®®æå¡',
    'å¬è¯´ãæ¤ççèãå°ç¨åºæ¯æ¤çå±çâå­¦ä¹ å¼ºå½â',
    'å©ç¨ãæ¤ççèãå°ç¨åºéæ¶éå°å·é¢ï¼å¯ä»¥ææå©ç¨ç¢çæ¶é´å­¦ä¹ æ¤çç¥è¯',
    'å¬è¯´å¨å½åå°çæ¤å£«é½å¨ãæ¤ççèãå°ç¨åºç­é¢âå¼é»âï¼è¿è½å¨âä¸çæåâç§åºèªå·±çåå­',
    'å¯ä»¥ç¨ãæ¤ççèãå°ç¨åºç»ä¹ å»é¢èªå·±çé¢åº',
    'èç³»æä»¬è¯ç¨ãå¸®è´¨æ§ãæ¨¡åï¼ææºå³å¯è¿è¡è´¨æ§æ£æ¥',
    'ãå¸®è´¨æ§ã æ¨¡åå¯ä»¥æ§è¡ä¸çº§ãäºçº§ãä¸çº§è´¨æ§ç±»å',
    'ç¨ãå¸®è´¨æ§ã æ¨¡åæ§è¡å®æ£æ¥ä»»å¡åï¼åç»­è¿æâæç»­æ¹è¿âç¯è',
    'ææ ·åæ è´¨æ§æ£æ¥çæåµï¼ ãå¸®è´¨æ§ãæ¨¡åä¸­çâææå¾âå¯ä»¥è¯´æ¯æå¥½çéæ©',
    'ææºç¹ç¹å³å¯æç­ï¼æå®èªå¨éç¥ç§å®¤æåï¼æç­æ¨¡åãè¶£æç­ãè°è¿æ²¡æç¨ï¼',
    'ãè¶£æç­ãæ¯æAãPãNåèªå®ä¹ç­åä¸ªç­ç§ï¼æ¤å£«é¿å¯ä»¥æ¸æ°ç»è®¡ç­ç§ä¸ªæ°ãå·¥æ¶ï¼è¿å¯ä»¥å¯¼åºexcelè¡¨æ ¼è¿è¡æ·±åº¦åæ',
    'æä½èè¯æ³åè½»æ¾ï¼å¯ä»¥ç¨ææºè¿è¡âå¿«æ·è¯åâ',
    'çè®ºèè¯å¯ä»¥è®¾ç½®åè®¸ç¦»å¼çé¢çæ¬¡æ°ï¼ææçé²æ­¢èè¯ä½å¼'
  ];
  tip: string;
  changeTipInterval: any;

  constructor(@Inject('instanceConfigHolder') private instanceConfigHolder: InstanceConfigHolderService) {}

  ngOnInit() {
    this.tip = this.tips[Math.floor(Math.random() * this.tips.length)];

    this.changeTipInterval = setInterval(() => {
      this.tip = this.tips[Math.floor(Math.random() * this.tips.length)];
    }, 8000);
  }

  ngOnDestroy() {
    clearInterval(this.changeTipInterval);
  }

  get message() {
    return this.instanceConfigHolder.config.message;
  }
}
